import { type UseMutationOptions } from "@tanstack/react-query";

import { type ErrorType } from "@vega-api/configs";
import { useRevokeRole } from "@vega-api/generated/auth-permission-v1/auth-permission-v1";
import { type RevokeRoleParams } from "@vega-api/generated/types/revokeRoleParams";
import { useStatusPopup } from "@vega-core/hooks/useStatusPopup";
import { m } from "@vega-core/paraglide/messages";

type RevokeRolesMutationOptions = UseMutationOptions<
  void,
  ErrorType<unknown>,
  { roleId: string; params: RevokeRoleParams }
>;

export const useRevokeRoles = () => {
  const { setError } = useStatusPopup();

  const { mutate: revokeRole, isPending: isPendingRevokeRole } = useRevokeRole({
    mutation: {
      onError: () => {
        setError({
          title: m.userManagement_permissions_statusRevokeError(),
        });
      },
    },
  });

  const deleteRole = (
    {
      userId,
      subjectId,
      roleId,
    }: {
      userId: string;
      roleId: string;
      subjectId?: string;
    },
    options?: RevokeRolesMutationOptions,
  ) => {
    revokeRole(
      {
        roleId,
        params: {
          userId,
          subjectId,
        },
      },
      options,
    );
  };

  return { revokeRole: deleteRole, isPendingRevokeRole };
};
